import "./NavBarStyles.css";

import React, {useState} from "react"
import { Link}  from "react-router-dom"

import{FaBars , FaTimes} from "react-icons/fa"



const NavBar = () => {
    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);
    
    const [color,setColor ] =useState(false);
    const changeColor =() => {
        if(window.scrollY >=100){
            setColor(true);
        }else{
            setColor(false);
        }
    }

    window.addEventListener("scroll", changeColor);

    return (
    <div className={color ? "header header-bg" : "header"}>
        <Link to="/"> 
            <h1>H.S.H.A</h1>
        </Link>
        <ul className= {click ? "nav-menu active" : "nav-menu"}>
  
            <li>
                <Link to="/Contact" onClick={handleClick}>יצירת קשר</Link>
            </li>
            <li>
                <Link to="/About" onClick={handleClick}>עלינו</Link>
            </li>
            <li>
                <Link to="/Project" onClick={handleClick}>פרוייקטים</Link>
            </li>
            <li>
                <Link to="/" onClick={handleClick}>בית</Link>
            </li>

 
        </ul>
        <div className="hamburger" onClick={ handleClick}>
        {click  ? ( <FaTimes size={20}  style={{color: "#fff"}}/>) : (<FaBars size={20}  style={{color: "#fff"}}/>) }
       
        

        </div>

    </div>
        

  );
}

export default NavBar;
